
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { DateRange } from 'react-day-picker';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { DateRangeFilterPicker } from '@/components/DateRangeFilterPicker';

interface PaymentsFilterProps {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  paymentMethod: string;
  setPaymentMethod: (value: string) => void;
  dateRange: DateRange | undefined;
  setDateRange: (value: DateRange | undefined) => void;
}

const PaymentsFilter: React.FC<PaymentsFilterProps> = ({
  searchQuery,
  setSearchQuery,
  paymentMethod,
  setPaymentMethod,
  dateRange,
  setDateRange
}) => {
  return (
    <div className="space-y-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
          <Input
            placeholder="Search by name, ID or email"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-10"
          />
        </div>
        
        <Select
          value={paymentMethod}
          onValueChange={setPaymentMethod}
        >
          <SelectTrigger>
            <SelectValue placeholder="Payment Method" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Methods</SelectItem>
            <SelectItem value="bank_transfer">Bank Transfer</SelectItem>
            <SelectItem value="paypal">PayPal</SelectItem>
            <SelectItem value="venmo">Venmo</SelectItem>
            <SelectItem value="zelle">Zelle</SelectItem>
          </SelectContent>
        </Select>
        
        <DateRangeFilterPicker 
          dateRange={dateRange} 
          onChange={setDateRange} 
        />
      </div>
    </div>
  );
};

export default PaymentsFilter;
